import * as React from "react"
import { cn } from "~/common/cn"

interface TagProps {
  children: React.ReactNode
  className?: string
  selected?: boolean
  onRemove?: () => void
  onClick?: () => void
}

const Tag = React.forwardRef<HTMLSpanElement, TagProps>(
  ({ className, children, selected = false, onRemove, onClick, ...props }, ref) => (
    <span
      ref={ref}
      className={cn(
        "inline-flex items-center rounded px-2 py-1 text-xs",
        selected ? "bg-postal-purple text-white" : "bg-tag-bg",
        className
      )}
      onClick={onClick}
      {...props}
    >
      {children}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          className="text-postal-purple:bg-white ml-1 inline-flex h-3 w-3 flex-shrink-0 items-center justify-center rounded-full focus:outline-none"
        >
          <span className="sr-only">Remove</span>
          <svg className="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
            <path strokeLinecap="round" strokeWidth="1.5" d="m1 1 6 6m0-6L1 7" />
          </svg>
        </button>
      )}
    </span>
  )
)
Tag.displayName = "Tag"

export { Tag }
